import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import OrderPage from "pages/Order";
import AdminPage from "pages/Admin";
import ConfirmPage from "pages/Confirmation";

export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={OrderPage} />
        <Route path="/admin" exact component={AdminPage} />
        <Route path="/confirm" exact component={ConfirmPage} />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
}
